import type { HowRelayWorksStage } from "./types";

export const describeTheProjectStage: HowRelayWorksStage = {
  slug: "describe-the-project",
  number: 2,
  name: "Describe the project",
  who: "mixed",
  whoLabel: "You or AI",
  oneLiner:
    "Tell Relay what you're building, who it's for and what \"done\" looks like. Optional for building; needed for tests.",
  whatItIs:
    "A project is one product or repository. Its background tells people and AI partners what you're building and for whom, what's in and out of scope, and the features, each with its key outcomes (the plain-English results that prove it works). AI partners read the background before they spec or build. Test-A-Feature uses the features and key outcomes to organise your tests.",
  youDo: [
    "Open Create-A-Project and start a New Project, or open an existing one.",
    "Fill in Project Setup (name, repository and where it lives), Background, Requirements, and Features with their key outcomes. You can ask your AI partner to draft any of it.",
    "Say what you do with finished work (merge and deploy, merge and release, or your own step).",
    "Save Draft while you work, and Publish when it's right. AI partners only see published projects.",
    "Give a feature a details document if it needs more than a description. AI partners can read it.",
    "Write standing rules with roles, not names, and never ask agents to wait for a person. Relay points out both as you type.",
  ],
  aiDoes: [
    "Drafts or updates the background when you ask.",
    "Reads it before speccing or building, so its work matches what you said.",
    "Can suggest features from what's already in your backlog.",
    "Add key outcomes at the end of a feature's list. Never reorder or delete them: test cases point at an outcome by its position, so moving one makes existing cases check the wrong thing. To retire an outcome, edit its text to say it is retired.",
    "Each project has a codebase map: a short file in its repo that tells AI partners where things are. The first build on a new project creates it.",
  ],
  ifWrong:
    "If a build is refused because the project has no working folder, set the project's working directory in its settings, then re-queue the track.",
  goThere: "Open Create-A-Project →",
};
